export default __webpack_public_path__ + "static/media/me.c267cf3f.jpg";